import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class BrowserTitleService {
  private readonly baseTitle: string;

  private readonly staticRouteSuffixes: { [key: string]: string } = {
    'supplier-group': 'Group search',
    company: 'Company search',
    sites: 'Site search',
    contacts: 'Contacts',
    workflow: 'Workflows',
    orbis: 'Orbis',
    administration: 'Admin',
    bvd: 'Import',
    logout: 'logout'
  };

  constructor(private readonly titleService: Title) {
    const currentTitle = this.titleService.getTitle();
    const bootTitle = (window as any).sTitle;
    this.baseTitle = currentTitle && currentTitle.trim() ? currentTitle.trim() : (bootTitle && String(bootTitle).trim() ? String(bootTitle).trim() : ':: ISA ::');
  }

  updateForUrl(url: string): void {
    const routeKey = this.getPrimaryRoute(url);

    if (routeKey === 'supplier-group-details' || routeKey === 'company-details' || routeKey === 'site-details') {
      this.setSuffix('');
      return;
    }

    this.setSuffix(this.staticRouteSuffixes[routeKey] || '');
  }

  setGroupName(name: string): void {
    this.setSuffix(name);
  }

  setCompanyName(name: string): void {
    this.setSuffix(name);
  }

  setSiteName(name: string): void {
    this.setSuffix(name);
  }

  private setSuffix(suffix: string): void {
    const normalizedSuffix = suffix ? suffix.trim() : '';
    const nextTitle = normalizedSuffix ? `${this.baseTitle} ${normalizedSuffix}` : this.baseTitle;
    this.titleService.setTitle(nextTitle);
  }

  private getPrimaryRoute(url: string): string {
    const cleanUrl = (url || '').split('?')[0].split('#')[0];
    const segments = cleanUrl.split('/').filter(Boolean);
    return segments.length > 0 ? segments[0] : '';
  }
}